import modalHtml from "./welcome-modal-html.html";
import {clientConfig} from "../../../main-app/config/client-config";

export default class WelcomeModal {

    constructor(querySchedulingAppInputsHandler, loadQueryModal, preloaderHandler) {
        $("body").append(modalHtml);
        this.modal = $("#querySchedulingAppWelcomeModal");
        this.querySchedulingAppInputsHandler = querySchedulingAppInputsHandler;
        this.loadQueryModal = loadQueryModal;
        this.form = $("#querySchedulingAppWelcomeModal form")[0];
        this.welcomeToken = $("#welcomeToken");
        this.preloaderHandler = preloaderHandler;
        this.action = null;
        this.welcomeActions = $(".welcome-action");
    }

    init() {
        const self = this;
        const urlParams = new URLSearchParams(window.location.search);
        const email = decodeURIComponent(urlParams.get('email'));
        const queryName = decodeURIComponent(urlParams.get('queryName'));
        const query = decodeURIComponent(urlParams.get('query'));
        const token = decodeURIComponent(urlParams.get('token'));
        if (token === "null") {
            self.modal.modal("show");
        }
        self.initForm();
        self.welcomeActions.on("click", function (){
            self.action = $(this).attr("customAction");
        })
    }

    create(){
        const self = this;
     //   self.querySchedulingAppInputsHandler.reset();
        self.modal.modal("hide");
    }

    load(){
        const self = this;
        self.modal.modal("hide");
        self.loadQueryModal.show();
    }

    initForm() {
        const self = this;
        self.form.addEventListener('submit', async function (event) {
            event.preventDefault();
            self.preloaderHandler.show();
            const inputs = document.querySelectorAll('#querySchedulingAppWelcomeModal form');
            const inputWrappers = document.querySelectorAll('#querySchedulingAppWelcomeModal form .query-scheduling-app-input-wrapper');
            inputs.forEach(input => {
                input.classList.remove('is-invalid');
                input.classList.remove('is-valid');
            });
            inputWrappers.forEach(inputWrapper => {
                inputWrapper.classList.add('was-validated');
            });
            if (!self.form.checkValidity()) {
                self.preloaderHandler.hide();
                return;
            }
            try {
                const invalidInputs = await self.customValidation();
                if (invalidInputs.length) {
                    invalidInputs.forEach(invalidInput => {
                        invalidInput.input.parentElement.querySelector(".invalid-feedback").innerText = invalidInput.message;
                        invalidInput.input.classList.add('is-invalid')
                    });
                    self.preloaderHandler.hide();
                    return;
                }
                self.querySchedulingAppInputsHandler.token.val(self.welcomeToken.val());
                self[self.action]();
            }
            catch (e){
                console.error(e)
            }
            self.preloaderHandler.hide();
        }, false);
    }

    async customValidation() {
        const self = this;
        const output = [];
        const tokenValidationResult = await self.validateToken();
        if (!tokenValidationResult) {
            output.push({
                input: self.welcomeToken[0],
                message: "Unauthorized"
            });
        }
        return output;
    }

    async validateToken() {
        const self = this;
        const jumpGateResponse = await self.executeTokenValidation();
        return jumpGateResponse.code === 200;
    }

    executeTokenValidation() {
        const self = this;
        return $.ajax({
            url: clientConfig.appEndpoint + "app/validate-token?token=" + self.welcomeToken.val(),
            type: 'GET',
            dataType: 'json',
            cache: false,
        });
    }
}